import React from 'react';
import { Button, IconButton, Paper, Stack, TextField, useTheme } from '@mui/material';
import LinkOffIcon from '@mui/icons-material/LinkOff';

const LinkMenu = ({ url, setUrl, inputRef, onSubmit, onRemove, isActive }) => {
	const theme = useTheme();

	const minimalInputTheme = theme.components.MuiInputBase.styleOverrides.minimal;

	const inputProps = { fontWeight: 400 };

	return (
		<Paper sx={{ p: 1, minWidth: 260 }}>
			<Stack direction='row' spacing={2} alignItems={'center'}>
				<TextField
					inputRef={inputRef}
					variant='standard'
					size='small'
					placeholder='https://example.com'
					value={url}
					onChange={(e) => setUrl(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							e.preventDefault();
							e.defaultMuiPrevented = true;
							onSubmit();
						}
					}}
					sx={{
						...minimalInputTheme,
						...inputProps,
						'& .MuiTextField-root': {
							...inputProps,
						},
						'& .MuiInputBase-input': {
							...inputProps,
						},
						'& .Mui-error': {
							marginLeft: 0,
						},
					}}
					slotProps={{
						input: {
							sx: {
								...inputProps,
								backgroundColor: 'transparent',
							},
						},
					}}
				/>
				<Stack direction='row' spacing={1} alignItems={'center'} justifyContent='flex-end'>
					{isActive && (
						<IconButton onClick={onRemove} size='small'>
							<LinkOffIcon />
						</IconButton>
					)}

					<Button variant='text' onClick={onSubmit} size='small'>
						Save
					</Button>
				</Stack>
			</Stack>
		</Paper>
	);
};

export default LinkMenu;
